// removed by extract-text-webpack-plugin
module.exports = {"skipLink":"_2ddmVSH"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Header/SkipToContent/index.css
// module id = ./template/components/Header/SkipToContent/index.css
// module chunks = client.sitechrome